import React from 'react';
import PropTypes from 'prop-types';
import interactionNumberSelector from '../../../../selectors/question/interactions/matchInteraction/InteractionNumberSelector';

const InteractionNumberPure = (props) => {
    const {
        number,
        numberClassList,
        scorableItemId,
    } = props;

    if (!number) {
        return null;
    }

    return number &&
        <span className={numberClassList} id={scorableItemId}>
            {number}
        </span>;
};

InteractionNumberPure.propTypes = {
    number: PropTypes.string,
    numberClassList: PropTypes.string.isRequired,
    scorableItemId: PropTypes.string.isRequired,
};

const InteractionNumber = props => (
    <InteractionNumberPure {...props} {...interactionNumberSelector.selectProps(props)} />
);

export default InteractionNumber;
